import { render } from "./ExtraField.vue?vue&type=template&id=d57e41a0&scoped=true"
import script from "./ExtraField.vue?vue&type=script&lang=js"
export * from "./ExtraField.vue?vue&type=script&lang=js"

import "./ExtraField.vue?vue&type=style&index=0&id=d57e41a0&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57e41a0"]])

export default __exports__